import type {
  DbaAccountBilling,
  DbaAccountDetail,
  DbaAccountRow,
  DbaActionRow,
  DbaComplimentaryBody,
  DbaDiscountRow,
  DbaGrantCreditBody,
  DbaHubInviteBody,
  DbaHubInviteResult,
  DbaProvisionInput,
  DbaProvisionResult,
  DbaResendInviteResult,
  DbaSetDiscountBody,
} from '@vivport/backend/types/dba';

import { httpClient } from './http-client';

export function listAccounts(q: string): Promise<DbaAccountRow[]> {
  return httpClient.get<DbaAccountRow[]>('/dba/accounts', { params: q ? { q } : undefined });
}

export function getAccount(accountId: number): Promise<DbaAccountDetail> {
  return httpClient.get<DbaAccountDetail>(`/dba/accounts/${accountId}`);
}

export function listDiscounts(): Promise<DbaDiscountRow[]> {
  return httpClient.get<DbaDiscountRow[]>('/dba/discounts');
}

export function listActions(limit: number): Promise<DbaActionRow[]> {
  return httpClient.get<DbaActionRow[]>('/dba/actions', { params: { limit } });
}

export function setDiscount(email: string, body: DbaSetDiscountBody): Promise<DbaDiscountRow> {
  return httpClient.put<DbaDiscountRow, DbaSetDiscountBody>(`/dba/discounts/${encodeURIComponent(email)}`, body);
}

export function removeDiscount(email: string): Promise<DbaDiscountRow> {
  return httpClient.delete<DbaDiscountRow>(`/dba/discounts/${encodeURIComponent(email)}`);
}

export function activateComplimentary(accountId: number, body: DbaComplimentaryBody): Promise<DbaAccountBilling> {
  return httpClient.post<DbaAccountBilling, DbaComplimentaryBody>(
    `/dba/accounts/${accountId}/billing/complimentary`,
    body
  );
}

export function endComplimentary(accountId: number, body: DbaComplimentaryBody): Promise<DbaAccountBilling> {
  return httpClient.delete<DbaAccountBilling, DbaComplimentaryBody>(
    `/dba/accounts/${accountId}/billing/complimentary`,
    { data: body }
  );
}

export function grantCredit(accountId: number, body: DbaGrantCreditBody): Promise<DbaAccountBilling> {
  return httpClient.post<DbaAccountBilling, DbaGrantCreditBody>(`/dba/accounts/${accountId}/billing/credit`, body);
}

export function provisionAccount(input: DbaProvisionInput): Promise<DbaProvisionResult> {
  return httpClient.post<DbaProvisionResult, DbaProvisionInput>('/dba/accounts', input);
}

export function inviteHubMember(hubId: number, body: DbaHubInviteBody): Promise<DbaHubInviteResult> {
  return httpClient.post<DbaHubInviteResult, DbaHubInviteBody>(`/dba/hubs/${hubId}/members`, body);
}

export function resendInvite(memberId: number): Promise<DbaResendInviteResult> {
  return httpClient.post<DbaResendInviteResult>(`/dba/members/${memberId}/resend-invite`);
}
